import {JobPositionVI} from "./job-position/vi";
import {InsuranceConfigVI} from "./insurance/vi";
import {EmploymentTypeVI} from "./employment-type/vi";
import {categoryVI} from "./category/vi";
import {BenefitVI} from "./allowances-type/vi";
import {WorkplaceConfigVI} from "./work-location/vi";
import {GloneVI} from "./level-and-pay-grade/vi";
import {LaborContractVi} from "./labor-contract/vi";
import {RecordVI} from "./record/vi";
import {JobTitleVI} from "./job-title/vi";
import {CompanyRuleVI} from "./company-rules/vi";
import {ContractTypeVI} from "./contract-type/vi";

export const PersonnelSettingVI = {
    ...JobPositionVI,
    ...LaborContractVi,
    ...RecordVI,
    ...InsuranceConfigVI,
    ...GloneVI,
    ...WorkplaceConfigVI,
    ...EmploymentTypeVI,
    ...categoryVI,
    ...BenefitVI,
    ...JobTitleVI,
    ...CompanyRuleVI,
    ...JobTitleVI,
    ...ContractTypeVI
}